import { render, staticRenderFns } from "./SecondSupervisorReviews.vue?vue&type=template&id=49ed3436"
import script from "./SecondSupervisorReviews.vue?vue&type=script&lang=js"
export * from "./SecondSupervisorReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports